export default __webpack_public_path__ + "static/media/Morphix - 8869.c497ffdb.jpeg";